import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
	    account: null,
	    wallet: null,
	    secret:  null,	  
	    addressdeposit: null,
	    addresscontract:  null
  },
  getters: {
        account: (state) =>{
			//console.log('account.state：', state); 
			//console.log('account.state.account：', state.account);
			if(state==null || state.account== null) {
				var paccountKeystore = localStorage.getItem("account");
				//console.log('account.Keystore：', paccountKeystore); 
				if(paccountKeystore==null || paccountKeystore=='')
					state.account = null;
				else
				    state.account = JSON.parse(paccountKeystore);
			}
			return  state.account;
		},
		secret: (state) =>{
			if(state==null || state.secret== null) {
				var psecret = sessionStorage.getItem("secret");
				//console.log('account.Keystore：', paccountKeystore); 
				if(psecret==null || psecret=='')
					state.secret = null;
				else
				    state.secret = psecret;
			}
			return  state.secret;
		},
		wallet: (state) =>{ 
			return  state.wallet;
		},
		depositaddress: (state) =>{
			if(state==null || state.addressdeposit== null) {
				var paddress = sessionStorage.getItem("addressdeposit");
				//console.log('account.Keystore：', paccountKeystore); 
				if(paddress==null || paddress=='')
					state.addressdeposit = null;
				else
				    state.addressdeposit = paddress;
			}
			return  state.addressdeposit;
		},
        error: (state) => state.error,
        // mining: (state) => state.mining,
        // characterNFT: (state) => state.characterNFT,
        // characters: (state) => state.characters,
        // boss: (state) => state.boss,
        // attackState: (state) => state.attackState,
      },
  mutations: {
	setAccount(state, account) {
		console.log('setAccount()：state=', state); 
	    state.account = account;
		localStorage.setItem("account", JSON.stringify(account));
		console.log('setAccount()：state=', state); 
	},
	setSecret: (state, secret) =>{
		state.secret = secret; 
		sessionStorage.setItem("secret", secret); 
	},
	setWallet(state, wallet) {
	    state.wallet = wallet; 
	},	
	setDepositAddress: (state, address) =>{
		state.addressdeposit = address; 
		sessionStorage.setItem("addressdeposit", address); 
	},
	signOut(state) { 
		state.account = null;
		state.wallet=null;
		state.secret= null;
		localStorage.setItem("account", null);
		sessionStorage.setItem("secret", null);
		localStorage.removeItem("account");
		sessionStorage.removeItem("secret");
	}, 
	setError(state, error) {
	    state.error = error;
	},
	// setMining(state, mining) {
	//     state.mining = mining;
	// },
	// setCharacterNFT(state, characterNFT) {
	//     state.characterNFT = characterNFT;
	// },
	// setCharacters(state, characters) {
	//     state.characters = characters;
	// },
	// setBoss(state, boss) {
	//     state.boss = boss;
	// },
	// setAttackState(state, attackState) {
	//     state.attackState = attackState;
	// }
  },
  actions: { 
	  async setAccount(state, account) {
	      try {
			  state.account = account;
			  localStorage.setItem("account", JSON.stringify(account));
	           
	          // await dispatch("checkNetwork"); // 检查选择的网络
	          // await dispatch("fetchNFTMetadata"); //
	          // await dispatch("setupEventListeners");
	      } catch (error) {
	          console.log(error);
	          //commit("setError", "Account request refused.");
	      }
	  },
	  // async connect({ commit, dispatch }, connect) {
	  //     try {
	  //         const { ethereum } = window;
	  //         if (!ethereum) {
	  //             // 验证是否安装 Metamask
	  //             commit("setError", "Metamask not installed!");
	  //             return;
	  //         }
	  //         if (!(await dispatch("checkIfConnected")) && connect) {
	  //             // 验证连接状态
	  //             await dispatch("requestAccess");
	  //         }
	  //         await dispatch("checkNetwork"); // 检查选择的网络
	  //         await dispatch("fetchNFTMetadata"); //
	  //         await dispatch("setupEventListeners");
	  //     } catch (error) {
	  //         console.log(error);
	  //         commit("setError", "Account request refused.");
	  //     }
	  // },
	  // async checkNetwork({ commit, dispatch }) {
	  //     let chainId = await ethereum.request({ method: "eth_chainId" });
	  //     const goerliChainId = "0x5";
	  //     if (chainId !== goerliChainId) {
	  //         if (!(await dispatch("switchNetwork"))) {
	  //             commit(
	  //                 "setError",
	  //                 "You are not connected to the Goerli Test Network!"
	  //             );
	  //         }
	  //     }
	  // },
	  // async switchNetwork() {
	  //     try {
	  //         await ethereum.request({
	  //             method: "wallet_switchEthereumChain",
	  //             params: [{ chainId: "0x5" }],
	  //         });
	  //         return 1;
	  //     } catch (switchError) {
	  //         return 0;
	  //     }
	  // },
	  // async checkIfConnected({ commit }) {
	  //     const { ethereum } = window;
	  //     const accounts = await ethereum.request({ method: "eth_accounts" });
	  //     if (accounts.length !== 0) {
	  //         commit("setAccount", accounts[0]);
	  //         return 1;
	  //     } else {
	  //         return 0;
	  //     }
	  // },
	  // async requestAccess({ commit }) {
	  //     const { ethereum } = window;
	  //     const accounts = await ethereum.request({
	  //         method: "eth_requestAccounts",
	  //     });
	  //     commit("setAccount", accounts[0]);
	  // },
	  // async getContract({ state }) {
	  //     try {
	  //         const { ethereum } = window;
	  //         const provider = new ethers.providers.Web3Provider(ethereum);
	  //         const signer = provider.getSigner();
	  //         const connectedContract = new ethers.Contract(
	  //             state.contract_address,
	  //             EpicGame.abi,
	  //             signer
	  //         );
	  //         return connectedContract;
	  //     } catch (error) {
	  //         console.log(error);
	  //         console.log("connected contract not found");
	  //         return null;
	  //     }
	  // },
	  // async setupEventListeners({ state, commit, dispatch }) {
	  //     try {
	  //         const connectedContract = await dispatch("getContract");
	  //         if (!connectedContract) return;
	  //         connectedContract.on(
	  //             "CharacterNFTMinted",
	  //             async (from, tokenId, characterIndex) => {
	  //                 console.log(
	  //                     `CharacterNFTMinted - sender: ${from} tokenId: ${tokenId.toNumber()} characterIndex: ${characterIndex.toNumber()}`
	  //                 );
	  //                 const characterNFT =
	  //                     await connectedContract.checkIfUserHasNFT();
	  //                 console.log(characterNFT);
	  //                 commit(
	  //                     "setCharacterNFT",
	  //                     transformCharacterData(characterNFT)
	  //                 );
	  //                 alert(
	  //                     `Your NFT is all done -- see it here: https://testnets.opensea.io/assets/${
	  //                         state.contract_address
	  //                     }/${tokenId.toNumber()}`
	  //                 );
	  //             }
	  //         );
	  
	  //         connectedContract.on(
	  //             "AttackComplete",
	  //             async (newBossHp, newPlayerHp) => {
	  //                 console.log(
	  //                     `AttackComplete: Boss Hp: ${newBossHp} Player Hp: ${newPlayerHp}`
	  //                 );
	  //                 let boss = state.boss;
	  //                 boss.hp = newBossHp;
	  //                 commit("setBoss", boss);
	  
	  //                 let character = state.characterNFT;
	  //                 character.hp = newPlayerHp;
	  //                 commit("setCharacterNFT", character);
	  //             }
	  //         );
	  //     } catch (error) {
	  //         console.log(error);
	  //     }
	  // },
	  // async disableEventListeners({ state, commit, dispatch }) {
	  //     const connectedContract = await dispatch("getContract");
	  //     connectedContract.off("CharacterNFTMinted");
	  // },
	  // async fetchNFTMetadata({ state, commit, dispatch }) {
	  //     try {
	  //         const connectedContract = await dispatch("getContract");
	  //         const txn = await connectedContract.checkIfUserHasNFT();
	  //         if (txn.name) {
	  //             commit("setCharacterNFT", transformCharacterData(txn));
	  //         }
	  //     } catch (error) {
	  //         console.log(error);
	  //     }
	  // },
	  // async getCharacters({ state, commit, dispatch }) {
	  //     try {
	  //         const connectedContract = await dispatch("getContract");
	  //         const charactersTxn =
	  //             await connectedContract.getAllDefaultCharacters();
	  //         const characters = charactersTxn.map((characterData) =>
	  //             transformCharacterData(characterData)
	  //         );
	  //         commit("setCharacters", characters);
	  //     } catch (error) {
	  //         console.log(error);
	  //     }
	  // },
	  // async mintCharacterNFT({ commit, dispatch }, characterId) {
	  //     try {
	  //         const connectedContract = await dispatch("getContract");
	  //         const mintTxn = await connectedContract.mintCharacterNFT(
	  //             characterId
	  //         );
	  //         await mintTxn.wait();
	  //     } catch (error) {
	  //         console.log(error);
	  //     }
	  // },
	  // async fetchBoss({ state, commit, dispatch }) {
	  //     try {
	  //         const connectedContract = await dispatch("getContract");
	  //         const bossTxn = await connectedContract.getBigBoss();
	  //         commit("setBoss", transformCharacterData(bossTxn));
	  //     } catch (error) {
	  //         console.log(error);
	  //     }
	  // },
	  // async attackBoss({ state, commit, dispatch }) {
	  //     try {
	  //         const connectedContract = await dispatch("getContract");
	  //         commit("setAttackState", "attacking");
	  //         console.log("Attacking boss...");
	  //         const attackTxn = await connectedContract.attackBoss();
	  //         await attackTxn.wait();
	  //         console.log("attackTxn:", attackTxn);
	  //         commit("setAttackState", "hit");
	  //     } catch (error) {
	  //         console.error("Error attacking boss:", error);
	  //         setAttackState("");
	  //     }
	  // }
  },
  modules: {
  }
})
